// src/config/standards/index.js

// Import the subject standards you have implemented.
// Each subject file should export a default object whose top-level key is the subject name.
import MATHEMATICS_STANDARDS from './mathematics';
import ELA_STANDARDS from './ela';
import SCIENCE_STANDARDS from './science';
import OCCUPATIONAL_THERAPY_STANDARDS from './occupationalTherapy';
import PHYSICAL_ED_STANDARDS from './physicalEducation';
import DANCE_STANDARDS from './dance';
import VISUAL_ARTS_STANDARDS from './visualArts';
import MUSIC_STANDARDS from './music';
import HEALTH_STANDARDS from './health';
import TECHNOLOGY_STANDARDS from './technology';
import HISTORY_STANDARDS from './history';
import GEOGRAPHY_STANDARDS from './geography';

// NEW: Business & Careers
import BUSINESS_STANDARDS from './business';
import CAREERS_STANDARDS from './careers';

// Standalone tech-related subjects
import COMPUTER_SCIENCE_STANDARDS from './computerScience';
import CODING_STANDARDS from './coding';
import DIGITAL_CITIZENSHIP_STANDARDS from './digitalCitizenship';
import DIGITAL_LITERACY_STANDARDS from './digitalLiteracy';
import ISTE_STANDARDS from './iste';

// Newly added
import SPECIAL_ED_STANDARDS from './specialEducation';
import RELIGION_STANDARDS from './religion';

// NEW: Speech & Language
import SPEECH_LANGUAGE_STANDARDS from './speechLanguage';
import SEL_STANDARDS from './sel';
import FRENCH_STANDARDS from './french';
import SPANISH_STANDARDS from './spanish';
import ESL_STANDARDS from './esl';


// --- Future subjects (uncomment when their files exist and export the expected shape) ---
// import THEATER_STANDARDS from './theater';
// import MEDIA_ARTS_STANDARDS from './mediaArts';
// import WORLD_LANG_STANDARDS from './worldLanguages';
// import OTHER_STANDARDS from './other';

export const STANDARDS_BY_SUBJECT = {
  ...(MATHEMATICS_STANDARDS || {}),
  ...(ELA_STANDARDS || {}),
  ...(SCIENCE_STANDARDS || {}),
  ...(OCCUPATIONAL_THERAPY_STANDARDS || {}),
  ...(PHYSICAL_ED_STANDARDS || {}),
  ...(DANCE_STANDARDS || {}),
  ...(VISUAL_ARTS_STANDARDS || {}),
  ...(MUSIC_STANDARDS || {}),
  ...(HEALTH_STANDARDS || {}),
  ...(TECHNOLOGY_STANDARDS || {}),
  ...(HISTORY_STANDARDS || {}),
  ...(GEOGRAPHY_STANDARDS || {}),
  ...(RELIGION_STANDARDS || {}),

  // NEW: Business & Careers
  ...(BUSINESS_STANDARDS || {}),
  ...(CAREERS_STANDARDS || {}),

  // Standalone tech-related subjects
  ...(COMPUTER_SCIENCE_STANDARDS || {}),
  ...(CODING_STANDARDS || {}),
  ...(DIGITAL_CITIZENSHIP_STANDARDS || {}),
  ...(DIGITAL_LITERACY_STANDARDS || {}),
  ...(ISTE_STANDARDS || {}),

  // Newly added
  ...(SPECIAL_ED_STANDARDS || {}),
  ...(SPEECH_LANGUAGE_STANDARDS || {}),
  ...(SEL_STANDARDS || {}),
  ...(FRENCH_STANDARDS || {}),
  ...(SPANISH_STANDARDS || {}),
  ...(ESL_STANDARDS || {}),

  // Add these when the files exist:
  // ...(THEATER_STANDARDS || {}),
  // ...(MEDIA_ARTS_STANDARDS || {}),
  // ...(WORLD_LANG_STANDARDS || {}),
  // ...(OTHER_STANDARDS || {}),
};

export default STANDARDS_BY_SUBJECT;

// Optional named re-exports for convenient direct imports elsewhere
export {
  MATHEMATICS_STANDARDS,
  ELA_STANDARDS,
  SCIENCE_STANDARDS,
  OCCUPATIONAL_THERAPY_STANDARDS,
  PHYSICAL_ED_STANDARDS,
  DANCE_STANDARDS,
  VISUAL_ARTS_STANDARDS,
  MUSIC_STANDARDS,
  HEALTH_STANDARDS,
  TECHNOLOGY_STANDARDS,
  HISTORY_STANDARDS,
  GEOGRAPHY_STANDARDS,

  // NEW: Business & Careers
  BUSINESS_STANDARDS,
  CAREERS_STANDARDS,

  // Standalone tech-related subjects
  COMPUTER_SCIENCE_STANDARDS,
  CODING_STANDARDS,
  DIGITAL_CITIZENSHIP_STANDARDS,
  DIGITAL_LITERACY_STANDARDS,
  ISTE_STANDARDS,

  // Newly added
  SPECIAL_ED_STANDARDS,
  SPEECH_LANGUAGE_STANDARDS,
  SEL_STANDARDS,
  RELIGION_STANDARDS,
  FRENCH_STANDARDS,
  SPANISH_STANDARDS,
  ESL_STANDARDS,


  // THEATER_STANDARDS,
  // MEDIA_ARTS_STANDARDS,
  // WORLD_LANG_STANDARDS,
  // OTHER_STANDARDS,
};